import React, { createContext, useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import localforage from "localforage";
import { STORAGE_KEYS } from "../constants/storage";
import { LanguageContext } from "./LanguageContext";

export const VoiceContext = createContext();

export const VoiceProvider = ({ children }) => {
  const [voiceData, setVoiceData] = useState(null);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    if (language) {
      loadVoiceData(language);
    }
  }, [language]);

  const loadVoiceData = async (langKey) => {
    try {
      const allVoiceData = await localforage.getItem(STORAGE_KEYS.VOICE);
      if (allVoiceData?.[langKey]) {
        setVoiceData(allVoiceData[langKey]);
      } else {
        console.warn(`Voice data for ${langKey} not found in cache`);
        setVoiceData({});
      }
    } catch (error) {
      console.error("Failed to load voice data from cache:", error);
      setVoiceData({});
    }
  };

  return (
    <VoiceContext.Provider value={{ voiceData }}>
      {children}
    </VoiceContext.Provider>
  );
};

VoiceProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
